import { apiSlice } from "../api/apiSlice";

export const quizesApi = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getQuizesByVideoId: builder.query({
			query: (videoId) => `/quizzes?video_id=${videoId}`,
		}),
		getQuiz: builder.query({
			query: (quizId) => `/quizzes/${quizId}`
		}),
		getQuizzes: builder.query({
			query: () => "/quizzes"
		}),
		editQuiz: builder.mutation({
			query: ({ id, data }) => ({
				url: `/quizzes/${id}`,
				method: "PUT",
				body: data,
			}),
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				const result = await queryFulfilled;

				if (result?.data?.id) {
					// pessimistic cache update
					dispatch(
						apiSlice.util.updateQueryData(
							"getQuizzes",
							undefined,
							(draft) => {
								let indexToUpdate = draft.findIndex(
									(quiz) => quiz.id == arg.id
								);
								if (indexToUpdate !== -1) {
									draft[indexToUpdate] = result.data;
								}
							}
						)
					);

					dispatch(
						apiSlice.util.updateQueryData(
							"getQuiz",
							arg.id.toString(),
							(draft) => {
								Object.assign(draft, result.data);
							}
						)
					);
				}
			},
		}),
		deleteQuiz: builder.mutation({
			query: (id) => ({
				url: `/quizzes/${id}`,
				method: "DELETE",
			}),
			async onQueryStarted(id, { queryFulfilled, dispatch }) {
				// delete optismatically
				const patchResult = dispatch(
					apiSlice.util.updateQueryData(
						"getQuizzes",
						undefined,
						(draft) => {
							const indexToDelete = draft.findIndex(
								(quiz) => quiz.id == id
							);
							if (indexToDelete !== -1) {
								draft.splice(indexToDelete, 1);
							}
						}
					)
				);

				try {
					await queryFulfilled;
				} catch (error) {
					patchResult.undo();
				}
			},
		}),
		addQuiz: builder.mutation({
			query: (data) => ({
				url: "/quizzes",
				method: "POST",
				body: data,
			}),
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				const result = await queryFulfilled;

				if (result?.data?.id) {
					// pessimistic cache update
					dispatch(
						apiSlice.util.updateQueryData(
							"getQuizzes",
							undefined,
							(draft) => {
								draft.push(result.data);
							}
						)
					);
				}
			},
		}),
	}),
});

export const { 
	useGetQuizesByVideoIdQuery,
	useGetQuizQuery,
	useGetQuizzesQuery,
	useEditQuizMutation,
	useDeleteQuizMutation,
	useAddQuizMutation
} = quizesApi;
